export { default } from "./DoctorClaimPanel";
